<template>
  <svg
    :width="newArticleDetailsDisplay ? '16' : '24'"
    :height="newArticleDetailsDisplay ? '16' : '24'"
    viewBox="0 0 24 24"
    :class="newArticleDetailsDisplay ? 'mr-1' : 'mr-2'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 11L17.586 9.586L13 14.172V2H11V14.172L6.414 9.586L5 11L12 18L19 11Z"
      fill="currentColor"
    />
    <path d="M20 20H4V22H20V20Z" fill="currentColor" />
  </svg>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
  },
};
</script>
